<template src="./template.html"></template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'chat-header',
  props: {},
  computed: {
    ...mapState({
      venue: (state) => state.venue.current,
    }),
  },
  data() {
    return {}
  },
  methods: {
    closeChat() {
      this.$store.dispatch('toggleChatApp')
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/ChatHeader/index.vue